import { render, staticRenderFns } from "./Detail-Expense.vue?vue&type=template&id=026e312f&"
import script from "./Detail-Expense.vue?vue&type=script&lang=js&"
export * from "./Detail-Expense.vue?vue&type=script&lang=js&"
import style0 from "./Detail-Expense.vue?vue&type=style&index=0&id=026e312f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports